export default __webpack_public_path__ + "static/media/Logo.67e784c8.svg";